// extracted by mini-css-extract-plugin
export default {"carouselContainer":"CarouselSection_carouselContainer__uW4E3","dots":"CarouselSection_dots__tBtkZ"};